import React, { useContext, useEffect, useState } from 'react'
import Logo_path from '../../Components/Logo_path'
import VideoBoxSection from './VideoBoxSection'
import Description from './Description'
import RelatedVideos from './RelatedVideos'
import DescriptionNew from './DescriptionNew'
import { addcontext } from '../../ContextShare/ContextShare'
import { GetSpecificVideo, nextOrPrevVideos, nextOrPrevVideosBS, nextOrPrevVideosGov, nextOrPrevVideosRS } from '../../Services/allApi'
import PartVideos from './PartVideos'
import { Icon } from '@iconify/react';
import { toast } from 'react-toastify';
import { useNavigate, useParams } from 'react-router-dom'
import language from '../../language.json'

function VideoPlay() {
  const params=useParams()
  const videoIdFromUrl=params.vId
  const [vIdToUrl,setvIdToUrl]=useState()
  const {videoData,setVideoData}=useContext(addcontext)
  const {videoUrl,setVideoUrl}=useContext(addcontext)
  const {videoThumb,setVideoThumb}=useContext(addcontext)
  const {whichPageIsSendingData,setwhichPageIsSendingData}=useContext(addcontext)
  const {isPartAVailable,setIsPartAVailable}=useContext(addcontext)
  const [updateResponse,setupdateResponse]=useState()
  const {isPartClicked,setisPartClicked}=useContext(addcontext)
  const {newIdP,setnewIdP}=useContext(addcontext)
  // const [parVideos,setparVideos]=useState([1,2,3,4,5,6,7])
  const {langChanged,setlangChanged}=useContext(addcontext)
  const [currentLanguage, setCurrentLanguage] = useState();

  useEffect(()=>{
      setCurrentLanguage(localStorage.getItem('language')||'en')
},[currentLanguage,langChanged])

  useEffect(()=>{
    const newId=videoIdFromUrl?.replace(/:/g, '')
    setvIdToUrl(newId)
    if(newId){
      console.log(vIdToUrl);
      GetDetailsOFVideo(newId)
    }
  },[vIdToUrl,isPartClicked])
  const navigate=useNavigate()
  
  // get video details by mappingid and set it globally
  const GetDetailsOFVideo=async(nn)=>{
   const res=await GetSpecificVideo(nn)
   console.log('ressss',res);
   setVideoData(res?.data?.data)
   setVideoUrl(res?.data?.data?.video_url)
   setVideoThumb(res?.data?.data?.video_thumbnail)

   if(vIdToUrl){
    navigate(`/video/:${vIdToUrl}`);
}
  }

  // handle playing next video
  const handleNext=async(e)=>{
    try{
      const nextVideo=await nextOrPrevVideos(vIdToUrl)
      // console.log(videoData.video_id);
      // console.log(nextVideo);
      // setVideoUrl(e=='next'?nextVideo?.data.next_video_url.video_url:nextVideo?.data.previous_video_url.video_url)
      // setVideoThumb(e=='next'?nextVideo?.data.next_video_url.video_thumbnail:nextVideo?.data.previous_video_url.video_thumbnail)
      // setVideoData(e=='next'?nextVideo?.data.next_video_url:nextVideo?.data.previous_video_url)
    // }
    const newUrlParms=(e=='next'?nextVideo?.data?.next_video?.mapping_id:nextVideo?.data?.previous_video?.mapping_id)
    setvIdToUrl(newUrlParms)

      if(newUrlParms){
        navigate(`/video/:${newUrlParms}`)
        setupdateResponse(updateResponse+1)
        setnewIdP(newIdP+1)
    }
    }
    catch(error){
      toast.error('No video found!!')
    }
  }
  return (
    <div className='flex flex-col items-center' style={{ height: '100%', width: '100%', fontFamily: 'Ropa sans' }}>
      <div className='md:w-11/12 w-full md:mb-10 mb-4'>
        <div><Logo_path AdminOrHome={'Home'} Directory={'Video'} /></div>
      </div>

      <VideoBoxSection />

      {/* next prev views button */}
      <div className='flex justify-center w-full mt-2'>
        <div className='flex md:w-9/12 w-11/12 justify-between flex-row '>
          <div><div className='w-full flex flex-row items-center cursor-pointer hover:bg-primary rounded hover:text-white md:text-lg text-xs' onClick={()=>handleNext('prev')}>{language.Previous[currentLanguage]} <i className="fa-solid fa-backward ms-2"></i></div></div>
          <div><div className='w-full flex flex-row items-center cursor-pointer hover:bg-primary rounded hover:text-white md:text-lg text-xs' onClick={()=>handleNext('next')}>{language.Next[currentLanguage]} <i className="fa-solid fa-forward ms-2"></i></div></div>
          {/* download count */}
          <div ><div className='w-full items-center flex flex-row md:text-lg text-xs'><Icon icon="gis:layer-download" className='me-2' /><span>{videoData?.download_views} {language.Downloads[currentLanguage]}</span></div></div>
          
          <div><div className='w-full items-center md:text-lg text-xs'><i className="fa-regular fa-eye me-2"></i>{videoData?.video_views} {language.Views[currentLanguage]}</div></div>
        </div>
      </div>

      {/* Part of videos */}
      <PartVideos/>


        <DescriptionNew />

      <RelatedVideos />

    </div>
  )
}

export default VideoPlay